import { Tooltip, withStyles } from "@material-ui/core"


const LightTooltip = withStyles(theme => ({
  tooltip: {
    border: '1px solid black',
    color: theme.palette.secondary.main,
    backgroundColor: '#FFF',
    '& .MuiTooltip-arrow': {
      color: 'black'
    }
  }
}))(Tooltip)

export default LightTooltip